import { render } from "./Models.vue?vue&type=template&id=403315f0&lang=true"
import script from "./Models.vue?vue&type=script&lang=js"
export * from "./Models.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/StartUpIcons/Models.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "403315f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('403315f0', __exports__)) {
    api.reload('403315f0', __exports__)
  }
  
  module.hot.accept("./Models.vue?vue&type=template&id=403315f0&lang=true", () => {
    api.rerender('403315f0', render)
  })

}


export default __exports__